import { render, staticRenderFns } from "./ImportBranches.vue?vue&type=template&id=68224958&scoped=true"
import script from "./ImportBranches.vue?vue&type=script&lang=js"
export * from "./ImportBranches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68224958",
  null
  
)

export default component.exports